<template>
  <div class="vuepdf" style="margin-top : 3%">
    <div id="pdf">
      <v-btn
        :loading="loading"
        :disabled="loading"
        color="primary"
        @click="loading = true,pdfgen()"
      >Download PDF</v-btn>
    </div>
  </div>
</template>


<script>
import { gsfimageURI } from "../../assets/dataURI";
import { mapFields } from "vuex-map-fields";
export default {

  data() {
    return {
      loading: null,
      self: {},
      familyCancer: null,
      familyGeneTesting: null
    };
  },
   computed: {
    ...mapFields("patientQuestion", ["dataModel", "formID"])
  },
  mounted(){
         this.self = this.dataModel.filter(person => {
      return person.relationship === "self";
    })[0];
    this.familyCancer = this.dataModel.filter(person => {
      return person.isCancer === true;
    });

    this.familyGeneTesting = this.dataModel.filter(person => {
      return person.isgeneTest !== "No";
    });
  },
  methods: {
       readableTrueFalse(item) {
      if (item === true) {
        return "Yes";
      } else {
        return "No";
      }
    },
       cancerPage() {
      if (this.familyCancer.length === 0) {
        return [];
      }
      return [
        {
          pageBreak: "before",
          layout: "noBorders",
          style: "tableTop",
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text: "Cancer conditions",
                  fillColor: "#00c2e2",
                  color: "white",
                  alignment: "center",
                  bold: true,
                  fontSize: 14
                }
              ]
            ]
          }
        },

        {
          table: {
            widths: [100, "*", "*", "*", "*"],
            headerRows: 1,
            // keepWithHeaderRows: 1,
            body: this.familyCancerData()
          }
        }
      ];
    },


      familyCancerData() {
      var data = [
        ["Name", "Relationship", "Cancer Name", "Age Diagnosed", "Notes"]
      ];
      this.dataModel.forEach(element => {
        if (element.isCancer === true) {
          for (var i = 0; i < element.cancerConditions.length; i++) {
            var row = [];
            if (i === 0) {
              row = [
                {
                  rowSpan: element.cancerConditions.length,
                  text: element.name
                },
                {
                  rowSpan: element.cancerConditions.length,
                  text: element.relationship
                },
                element.cancerConditions[i],
                element.cancerConditionsDx[element.cancerConditions[i]],
                {
                  rowSpan: element.cancerConditions.length,
                  text: element.notes
                }
              ];
            } else {
              row = [
                "",
                "",
                element.cancerConditions[i],
                element.cancerConditionsDx[element.cancerConditions[i]],
                ""
              ];
            }
            data.push(row);
          }
        }
      });
      return data;
    },

     familyTable() {
      var data = [
        [
          "Name",
          "Relationship",
          "Gender",
          "Living",
          "Age",
          "Cancer?",
          "Genetic testing?"
        ]
      ];
      this.dataModel.forEach(element => {
        element.name == "" ? (element.name = "Not Provided") : element.name;

        var emptyTemplate = [
          element.name,
          this.formatRelationShip(element),
          element.gender,
          this.readableTrueFalse(element.isLiving),
          element.age,
          this.readableTrueFalse(element.isCancer),
          element.isgeneTest
        ];
        data.push(emptyTemplate);
      });
 
      return data;

    },
    formatRelationShip(element){
      if(element.hasOwnProperty('parents')){
        return element.relationship + "\n(parent : "+element.parents+")"
      }
      else{
         return element.relationship
      }
     
    },
     familyGeneticTestingData() {
      var data = [["Name", "Relationship", "Gene", "Mutation", "Lab", "Notes"]];
      this.dataModel.forEach(element => {
        var row = [];
        if (element.isgeneTest !== "No") {
          row = [
            element.name,
            element.relationship,
            element.geneTestDetail.geneName,
            element.geneTestDetail.mutationName,
            element.geneTestDetail.labName,
            element.notes
          ];
          data.push(row);
        }
      });
      return data;
    },
       geneTestPage() {
      if (this.familyGeneTesting.length === 0) {
        return [];
      }
      return [
        {
          pageBreak: "before",
          layout: "noBorders",
          style: "tableTop",
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text: "Genetic testing",
                  fillColor: "#00c2e2",
                  color: "white",
                  alignment: "center",
                  bold: true,
                  fontSize: 14
                }
              ]
            ]
          }
        },
        {
          table: {
            widths: [70, "*", "*", 100, 80, "*"],
            headerRows: 1,
            // keepWithHeaderRows: 1,
            body: this.familyGeneticTestingData()
          }
        }
      ];
    },
 
   
    pdfgen: function() {
      //turn the icon to base64 and use it in the pdf
      var pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      var docDefinition = {
        background: function(currentPage, pageSize) {
          return {
            image: gsfimageURI,
            opacity: 0.2,
            width: 200,
            absolutePosition: {
              x: pageSize.width / 3,
              y: pageSize.height / 2.4
            }
          };
        },
        content: [
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: "auto",
                stack: [
                  {
                    image: gsfimageURI,
                    width: 200,
                    alignment: "left",
                    link: "https://geneticsupportfoundation.org"
                  }
                ]
              },
              {
                // star-sized columns fill the remaining space
                // if there's more than one star-column, available width is divided equally
                width: "*",
                text: ""
              },
              {
                // fixed width
                width: 210,
                text:
                  "2010 Caton Way SW \nSuite #12 \nOlympia, WA  98502\nP: 844-743-6384     F: 844 813 3892",
                alignment: "right",
                fontSize: 9,
                color: "#006397"
              }
            ],
            // optional space between columns
            columnGap: 10
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 5,
                x2: 520,
                y2: 5,
                lineWidth: 0.5,
                color: "#006397"
              }
            ]
          },
          {
            columns: [
              {
                width: "auto",
                text: "Patient Family History for " + this.self.name,
                color: "#00c2e2",
                style: "header"
              },
              {
                width: "*",
                text: ""
              },
              {
                // fixed width
                width: 100,
                text: "ID : " + this.formID,
                alignment: "right",
                style: "id"
              }
            ],
            // optional space between columns
            columnGap: 10
          },
          {
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: "50%",
                text:
                  "Patient Name: " +
                  this.self.name +
                  "\n Gender: " +
                  this.self.gender +
                  "\nAge: " +
                  this.self.age +
                  "\nSubmit Time: " +
                  this.$moment().format("YYYY-MM-DD HH:mm:ss"),
                fontSize: 11
              },

              {
                // fixed width
                width: "50%",

                text:
                  "Phone Number: Not Provided\nEmail Address: Not Provided\nAddress: Not Provided",

                fontSize: 11
              }
            ],
            // optional space between columns
            columnGap: 20
          },
          {
            layout: "noBorders",
            style: "tableTop",
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    text: "Family Members",
                    fillColor: "#00c2e2",
                    color: "white",
                    alignment: "center",
                    bold: true,
                    fontSize: 14
                  }
                ]
              ]
            }
          },

          {
            layout: "lightHorizontalLines",
            table: {
              widths: ["*", "*", 40, 40, 30, 60, 90],
              headerRows: 1,
              body: this.familyTable()
            }
          },

          this.cancerPage(),
          this.geneTestPage()
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 10, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5]
          },
          tableExample: {
            margin: [0, 5, 0, 15]
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black"
          },
          id: {
            margin: [0, 15, 0, 0],
            fontsize: 13
          },
          tableTop: {
            margin: [0, 10, 0, 15]
          }
        },
        defaultStyle: {
          // alignment: 'justify'
        }
      };
      pdfMake.createPdf(docDefinition).download(this.formID + ".pdf", () => {
        this.loading = null;
      });
    },
  }
};
</script>
